import Vuex from 'vuex'
import cookie from 'js-cookie';

const store = ()=>{
  return new Vuex.Store({
    state: {
      editor_status: {
        code_id: 0,
        title: 'untitled',
        description: '',
        is_public: 0,
        line: 0,
        row: 0,
        col: 0,
        count: 0,
        language: 'php7',
        author: 'anonymous',
        theme: 'monokai',
        content: '',
        size: '12px',
        line_number_visible: true,
        charset_visible: false,
        grammar: true,
        keymap: 'normal',
      },
      user: null,
      token: null,
    },
    mutations: {
      SetUser(state, params){
        state.user = params.user;
        cookie.set('user', params.user, params.expire_in);
      },
      SetToken(state, params){
        state.token = params.token;
        cookie.set('token', params.token, params.expire_in);
      },
      RemoveUser(state, params){
        cookie.remove('user');
        cookie.remove('token');
        state.user = null;
        state.token = null;
      },
      ChangeEditorStatus(state, params){
        state.editor_status = params;
      },
    },
    getters: {
      user: state=>{
        return state.user;
      },
      token: state=>{
        return state.token;
      },
      access_token: state=>{
        let access_token = null;
        try{
          access_token = state.token.access_token;
        }catch(e){
          // ...
        }
        return access_token;
      },
      editor_status: (state, getter)=>{
        return state.editor_status
      }
    },
    actions: {
      GetUserFromCookie({state, commit}){
        try{
          state.token = JSON.parse(cookie.get('token'));
          $vue.$fetch.user.user_info().then(data=>{
            state.editor_status.author = data.username;
            state.user = data;
          })
        }catch(e){
        }
      }
    }
  })
};

export default store
